module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.dialogVisible,
      "size": "large",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.closeCallback
    }
  }, [_c('el-form', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "订单号"
    },
    model: {
      value: (_vm.query.OrderCode),
      callback: function($$v) {
        _vm.$set(_vm.query, "OrderCode", $$v)
      },
      expression: "query.OrderCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开始日期"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": ""
    },
    model: {
      value: (_vm.query.startDate),
      callback: function($$v) {
        _vm.$set(_vm.query, "startDate", $$v)
      },
      expression: "query.startDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结束日期"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": ""
    },
    model: {
      value: (_vm.query.endDate),
      callback: function($$v) {
        _vm.$set(_vm.query, "endDate", $$v)
      },
      expression: "query.endDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onQuerySubmit()
      }
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading2),
      expression: "loading2"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.lists,
      "element-loading-text": "拼命加载中",
      "border": "",
      "router": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "收款金额",
      "prop": "ReceiveAmount"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "已认款金额",
      "prop": "ParagraphAmount"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "代理商名称",
      "prop": "AgentName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "金蝶编码",
      "prop": "KingdeeAgentCode"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "收款时间",
      "prop": "FDate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "收款标题",
      "prop": "FTitle"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "收款订单号",
      "prop": "FNumber"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "收款摘要",
      "prop": "FExplanation"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "金蝶代理商名称",
      "prop": "FCustomerName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "btm-action",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.query.pageIndex,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.query.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.query.total * 1
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2531fa13!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CRMAgentAccountManage/components/kingdeeDialog/index.vue
// module id = 1422
// module chunks = 1